var map = {
	"./amex.svg": 85121,
	"./diners.svg": 79890,
	"./discover.svg": 7928,
	"./jcb.svg": 67367,
	"./mastercard.svg": 56945,
	"./unionpay.svg": 13222,
	"./unknown.svg": 10217,
	"./visa.svg": 74235,
	"./wrong.svg": 14920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45449;